<template>
  <div class="time">
    <el-date-picker
            v-model="value"
            :type="type"
            placeholder="选择日期时间">
    </el-date-picker>
  </div>
</template>

<script>
import {formatDate} from '../utils/date'
export default {
  props: ['birthDay', 'type'],
  data () {
    return {
      value: ''
    }
  },
  watch: {
    birthDay(newVal) {
      this.value = newVal
    }
  },
  updated () {
    // if(this.value)
    console.log(this.value)
    if(!this.value) return
    let date = new Date(this.value)
    let time = formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    this.$emit('time', time)
  },
  activated() {
    this.value = ''
  }
}
</script>

<style scoped lang="less" type="text/less">
.time{
  .el-date-editor.el-input{
    width: 340px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Time.vue